export async function clearAllStorage(): Promise<void> {
	try {
		localStorage.clear();
	} catch (e) {
		console.error("localStorage.clear:", e);
	}
	try {
		sessionStorage.clear();
	} catch (e) {
		console.error("sessionStorage.clear:", e);
	}
	// try {
	// 	await clearAllProductDB();
	// } catch (e) {
	// 	console.error("clearAllProductDB:", e);
	// }
}
